
























































































































































import { Component, Vue } from 'vue-property-decorator';
import Agreement from '../article/agreement.vue';
import About from '../article/about.vue';
import Help from '../article/help.vue';
import ProblemArticle from './problem_article.vue';
import PrivacyPolicies from '../article/privacyPolicies.vue';
// import homeFooter from "@/views/home/component/footer.vue";
import Tail from '@/layouts/tail.vue';
import float from '@/views/home/component/float.vue';
import Share from '@/components/shares/index.vue';
import { getHelpUrl } from '@/utils/getHost';
@Component({
  components: {
    Agreement,
    About,
    PrivacyPolicies,
    // homeFooter,
    Tail,
    Help,
    ProblemArticle,
    float,
    Share,
  },
})
export default class Article extends Vue {
  /**
   * 声明变量
   */
  private articleDetail: any = null; // 文章详情
  private articleName: any = null; // 搜索
  private articleId: any = null; // 当前文章id
  private articleType: any = null; // 当前文章类型
  private showType: any = 0; // 显示类型   0：文章  2：在线帮助 4：问题反馈
  private defaultExpandedKeys: any = []; // 默认展开的节点的 key 的数组
  private currentNodeKey: any = ''; // 当前选中的节点
  private imgShow: any = false;
  private previewImg: any = ''; // 预览图片路径
  private historyList: any = []; // 历史记录列表
  private articleByTitleList: any = []; // 文章关键词列表
  private showHistoryList: any = false;
  private recommendList: any = []; // 相关推荐10篇
  private lastornext: any = []; // 相关推荐10篇
  private props: any = {
    label: 'name',
    children: 'zones',
    isLeaf: 'leaf',
  };
  private parent: any = [
    { name: '入门教程', articleTypeId: 10, id: 'introduction' },
    { name: '投票指引', articleTypeId: 1, id: 'vote' },
    { name: '问卷指引', articleTypeId: 9, id: 'questionnaire' },
    { name: '考试指引', articleTypeId: 11, id: 'exam' },
    { name: '接龙指引', articleTypeId: 12, id: 'solitaire' },
    { name: '关于我们', articleTypeId: 3, id: 'about' },
    { name: '视频教程', articleTypeId: 17, id: 'video' },
    { name: '在线帮助', articleTypeId: 2, id: 'help', leaf: true },
    { name: '问题反馈', articleTypeId: 4, id: 'problem', leaf: true },
  ];
  private level2parent: any = [
    { name: '快速入门', articleTypeSubId: 7, id: 'level1_7' },
    { name: '基本设置', articleTypeSubId: 1, id: 'level1_1' },
    { name: '页面设置', articleTypeSubId: 2, id: 'level1_2' },
    { name: '投票规则', articleTypeSubId: 3, id: 'level1_3' },
    { name: '报名设置', articleTypeSubId: 4, id: 'level1_4' },
    { name: '营销功能', articleTypeSubId: 5, id: 'level1_5' },
    { name: '其他设置', articleTypeSubId: 6, id: 'level1_6' },
  ];
  // private level2parentIntro: any = [
  //   { name: "投票评选", articleTypeSubId: 9, id: "level1_8" },
  //   { name: "问卷调研", articleTypeSubId: 10, id: "level1_9" },
  //   { name: "考试测评", articleTypeSubId: 11, id: "level1_10" },
  //   { name: "报名表单", articleTypeSubId: 12, id: "level1_11" },
  //   { name: "在线接龙", articleTypeSubId: 13, id: "level1_12" },
  //   { name: "在线收款", articleTypeSubId: 14, id: "level1_12" },
  //   { name: "在线预约", articleTypeSubId: 15, id: "level1_14" },
  // ];
  get nodeClass() {
    return (node: any) => {
      if (node.level === 1) {
        return 'level1';
      } else {
        if (String(node.key).indexOf('level1_') > -1) {
          return 'level2';
        } else {
          return 'level3';
        }
      }
    };
  }
  get processedArticleDetail() {
    return this.$tool.processArticleDetail(this.articleDetail.content);
  }
  private async created() {
    if (this.$subName == 'wenjuanjia') {
      this.parent = [
        { name: '投票指引', articleTypeId: 1, id: 'vote' },
        { name: '问卷指引', articleTypeId: 9, id: 'questionnaire' },
        { name: '考试指引', articleTypeId: 11, id: 'exam' },
        { name: '接龙指引', articleTypeId: 12, id: 'solitaire' },
        { name: '关于我们', articleTypeId: 3, id: 'about' },
        { name: '在线帮助', articleTypeId: 2, id: 'help', leaf: true },
        { name: '问题反馈', articleTypeId: 4, id: 'problem', leaf: true },
      ];
    }
    const articleId = this.$route.query.articleId;
    const articleType = this.$route.query.articleType;
    const articleTypeSubType = this.$route.query.articleTypeSubId;
    this.articleId = articleId;
    this.articleType = articleType;

    let articleTypeSubId: any = null;
    let parentId: any = null;
    if ((!articleId || articleId === '') && articleType !== '2' && articleType !== '4') {
      this.defaultExpandedKeys = ['introduction'];

      this.getArticleByTypeList(10).then((res) => {
        setTimeout(() => {
          const tree: any = this.$refs.tree;
          tree.setCurrentKey(res[0].id);
          this.getArticleDetail(res[0].id);
          this.articleId = res[0].id;
        }, 0);
      });
    } else {
      // 获取大类id
      parentId = this.parent.filter((el: any) => el.articleTypeId === Number(articleType))[0].id;

      // 获取子类id
      if (articleTypeSubType === '1' || articleTypeSubType === '2' || articleTypeSubType === '3' || articleTypeSubType === '4' || articleTypeSubType === '5' || articleTypeSubType === '6' || articleTypeSubType === '7') {
        articleTypeSubId = this.level2parent.filter((el: any) => el.articleTypeSubId === Number(articleTypeSubType))[0].id;
      }

      // if (articleTypeSubType === "10") {
      //   articleTypeSubId = this.level2parentIntro.filter(
      //     (el: any) => el.articleTypeSubId === Number(articleTypeSubType)
      //   )[0].id;
      // }
      if (articleType === '2' || articleType === '4') {
        // 在线帮助、问题反馈
        this.showType = Number(articleType);
        // 当前选中的节点
        this.defaultExpandedKeys = [parentId];
        this.currentNodeKey = parentId;
      } else if (articleType === '3' || articleType === '9' || articleType === '10' || articleType === '17') {
        this.showType = 0;
        this.getArticleDetail(this.articleId);

        this.defaultExpandedKeys = [parentId];
        this.currentNodeKey = Number(this.articleId);
      } else {
        this.showType = 0;
        this.getArticleDetail(this.articleId);

        if (articleTypeSubId) {
          this.defaultExpandedKeys = [parentId, articleTypeSubId];
        } else {
          this.defaultExpandedKeys = [parentId, 'level1_1'];
        }
        this.currentNodeKey = Number(this.articleId);
      }
    }
    this.getArticleByReadList();
    this.getLastOrNext();
    // 如果本地存储的数据historyList有值，直接赋值给data中的historyList
    const localHistoryList: any = localStorage.getItem('historyList_LONGYIXIU');
    if (JSON.parse(localHistoryList)) {
      this.historyList = JSON.parse(localHistoryList);
    }
    // this.historyList = ["历史记录1", "历史记录2"];
    console.log(this.historyList, 'this.historyList');
  }
  private toArticle(item: any) {
    this.handleNodeClick(item);
  }
  // 上一文章
  private getLastOrNext() {
    this.$apis
      .getLastOrNext({
        type: 3,
        articleType: 1,
      })
      .then((res) => {
        res.forEach((element: any) => {
          element.isList = true;
          element.id = element.articleId;
          element.articleTypeId = element.articleType;
        });
        this.lastornext = res;
      });
  }
  // 精选文档。获取相关推荐10篇
  private getArticleByReadList() {
    this.$apis
      .getArticleByReadList({
        systemType: 1,
        page: 1,
        pageSize: 10,
      })
      .then((res) => {
        res.data.forEach((element: any) => {
          element.isList = true;
          element.id = element.articleId;
        });
        this.recommendList = res.data;
      });
  }
  // 搜索
  private async inputSearchValue() {
    if (this.articleName) {
      this.showHistoryList = true;
      const data: any = await this.$apis.getArticleList({
        keyword: this.articleName,
        systemType: 1,
        page: 1,
        pageSize: 10,
      });
      data.data.forEach((element: any) => {
        element.isList = true;
      });
      this.articleByTitleList = data.data;
    }
  }
  private deleteHistory(name: any) {
    const i = this.historyList.indexOf(name);
    this.historyList.splice(i, 1);
    localStorage.setItem('historyList_LONGYIXIU', JSON.stringify(this.historyList));
  }
  // 显示历史记录
  private handleShowHistory() {
    if ((this.articleName === '' || !this.articleName) && this.historyList.length > 0) {
      this.showHistoryList = true;
    }
  }
  private showImg(e: any) {
    if (e.target.tagName === 'IMG') {
      this.previewImg = e.target.src;
      this.imgShow = true;
      window.addEventListener('keydown', this.handleEvent);
    }
  }
  private imgShowHandler() {
    this.imgShow = false;
    window.removeEventListener('keydown', this.handleEvent); // 页面销毁的时候解除
  }
  private handleEvent(event: any) {
    console.log(event);
    // 如阻止浏览器查找 Ctrl + F
    if (event.keyCode === 27) {
      this.imgShow = false;
    }
  }
  /**
   * 当前选中的节点
   */

  private currentChange(node: any, data: any) {
    const tree: any = this.$refs.tree;
    tree.setCurrentKey(this.articleId);
  }
  private async loadNode(node: any, resolve: any) {
    if (node.level === 0) {
      return resolve(this.parent);
    }
    // 获取投票指引子类
    if (node.level === 1) {
      if (node.data.articleTypeId === 1) {
        return resolve(this.level2parent);
      }
      //  else if (node.data.articleTypeId === 10) {
      //   return resolve(this.level2parentIntro);
      // }
      // 获取问卷指引、关于我们
      if ([3, 9, 11, 12, 10, 17].includes(node.data.articleTypeId)) {
        const data = await this.getArticleByTypeList(node.data.articleTypeId);
        return resolve(data);
      }
      return resolve([]);
    }
    //   获取投票指引子类里面的列表
    if (node.level === 2 && node.parent.data.articleTypeId === 1) {
      const data = await this.getArticleByTypeList(node.parent.data.articleTypeId, node.data.articleTypeSubId);
      // const tree: any = this.$refs.tree;
      // tree.setCurrentKey(52);
      return resolve(data);
    }
    return resolve([]);
  }
  // 获取文章列表
  private async getArticleByTypeList(articleTypeId: any, articleTypeSubId?: any) {
    const list = await this.$apis.getArticleByTypeList({
      articleTypeId,
      articleTypeSubId,
    });
    list.forEach((element: any) => {
      element.name = element.title;
      element.leaf = true;
      element.isList = true;
      if (element.id === Number(this.articleId)) {
        element.isChecked = true;
      }
    });
    return list;
  }
  /**
   * 选中左边分类
   */
  private handleNodeClick(data: any) {
    console.log(data);
    if (data.isList) {
      if (data.articleTypeSubId) {
        this.$router.push({
          path: `/help.html?articleId=${data.id}&articleType=${data.articleTypeId}&articleTypeSubId=${data.articleTypeSubId}`,
        });
        // window.location.href = `/help.html?articleId=${data.id}&articleType=${data.articleTypeId}&articleTypeSubId=${data.articleTypeSubId}`
      } else {
        this.$router.push({
          path: `/help.html?articleId=${data.id}&articleType=${data.articleTypeId}`,
        });
        // window.location.href = `/help.html?articleId=${data.id}&articleType=${data.articleTypeId}`
      }
    } else if (data.articleTypeId === 2) {
      this.$router.push({
        path: `/help.html?articleType=2`,
      });
      // window.location.href = `/help.html?articleType=2`
    } else if (data.articleTypeId === 4) {
      this.$router.push({
        path: `/help.html?articleType=4`,
      });
      // window.location.href = `/help.html?articleType=4`
    }
  }
  /**
   * 文章详情
   */
  private async getArticleDetail(articleId: any) {
    if (articleId !== null) {
      const articleDetail = await this.$apis.getArticleDetail({
        id: articleId,
      });
      this.articleDetail = articleDetail;
      // this.articleDataShow = false;
      document.title = this.articleDetail.title + '_' + this.$globalName;
    }
  }
  // 搜索后点击文章
  private handleClickSearch(item: any) {
    this.articleName = item.title;
    this.keyWordToLocal();
    this.handleNodeClick(item);
  }
  // 历史记录搜索
  private goSearchDetail(name: any) {
    console.log(name);
    this.articleName = name;
    this.searchArticle();
  }
  // 清空历史搜索记录
  private empty() {
    // this.$toast.success('清空历史搜索成功');
    localStorage.removeItem('historyList_LONGYIXIU');
    this.historyList = [];
    this.showHistoryList = false;
  }
  /**
   * 搜索
   */
  private searchArticle() {
    this.keyWordToLocal();
    if (this.articleName) {
      console.log(this.articleName);
      // window.location.href = '/help/search.html?q=' + this.articleName
      this.$router.push({
        path: '/help/search.html?q=' + this.articleName,
      });
    }
  }
  private keyWordToLocal() {
    // 没有搜索记录，把搜索值push进数组首位，存入本地
    if (!this.historyList.includes(this.articleName)) {
      this.historyList.unshift(this.articleName);
      localStorage.setItem('historyList_LONGYIXIU', JSON.stringify(this.historyList));
    } else {
      // 有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
      const i = this.historyList.indexOf(this.articleName);
      this.historyList.splice(i, 1);
      this.historyList.unshift(this.articleName);
      localStorage.setItem('historyList_LONGYIXIU', JSON.stringify(this.historyList));
    }
  }
  /**
   * 文章有用+1
   */
  private async getArticleUseful(articleId: any) {
    if (articleId !== null) {
      await this.$apis.getArticleUseful({
        id: articleId,
      });
      this.$message({
        message: '感谢您的反馈！',
        type: 'success',
      });
    }
  }
  /**
   * 文章无用+1
   */
  private async getArticleUseless(articleId: any) {
    if (articleId !== null) {
      await this.$apis
        .getArticleUseless({
          id: articleId,
        })
        .then(() => {
          window.open(getHelpUrl(), '_blank');
        });
    }
  }
  /**
   * 时间装换
   */
  private getTimeFormat(time: any) {
    if (time != null) {
      return this.$tool.getDateTime(time, 'YYYY-MM-DD');
    }
  }
}
